module.exports = __webpack_public_path__ + "img/app.57e71782.png";